<template>
    <ModalFormCard class="lg:min-w-[800px] modal-default" :action="'/subscription/' + subscription.id">
        <template #title>Cancel subscription</template>

        <template #default="{ saving, errors }">
            <input type="hidden" name="_method" value="DELETE" />

            <p class="font-semibold text-17">Your subscription</p>

            <SubscriptionBreakdown
                class="mt-6"
                :plan="subscription.plan"
                :industry="subscription.company.industry"
                :area="subscription.location_area"
                :productId="subscription.product_id"
            />

            <!-- <div class="py-6 border-b border-grey-500">
                <p class="text-15 font-semibold">
                    You are about to cancel your subscription and release {{ subscription.location_area.name }}
                </p>

                <p class="text-grey-900 text-14 pt-2">
                    There are currently 2 people on the waiting list tot receive roofing leads in {{ subscription.location_area.name }} –
                    they will be notified of your location's availabiblity upon cancellation.
                </p>
            </div> -->

            <Error class="mt-4" textClass="text-black font-semibold" :error="'You are about to cancel your subscription'" />
            <p class="text-grey-900 text-14 pt-2">
                Your subscription will cancel on the {{ $moment(subscription.current_ad_period ? subscription.current_ad_period.ads_period_to : subscription.ads_period_to).format('Do MMMM YYYY') }} and the following will be removed:
            </p>

            <p class="text-12 text-grey-900 mt-4 border-t border-grey-500 pt-6">Tick to confirm removal (all are required)</p>

            <div class="grid gap-2.5 mt-1 border-b border-grey-500 pb-6 pt-2">
                <InputCheckbox v-for='(value, name) in value.checkboxes' :name="name" :value="value" @clicked="set(name)" :label='true'>
                    <p class="text-14 pl-2">{{ typeof descriptions[name] == 'function' ? descriptions[name]() : descriptions[name] }}</p>
                </InputCheckbox>
                
                <!-- <InputCheckbox name="area" value="1" @clicked="set('area')">
                    <p class="text-14 pl-2">
                        Your location area ({{ subscription.company.industry.name }} - {{ subscription.location_area.name }})
                    </p>
                </InputCheckbox>

                <InputCheckbox name="domain" value="1" v-if="lastSubscription" @clicked="set('domain')">
                    <p class="text-14 pl-2">Your domain name</p>
                </InputCheckbox>

                <InputCheckbox name="numbers" value="1" @clicked="set('numbers')">
                    <p class="text-14 pl-2">Your local phone numbers</p>
                </InputCheckbox>

                <InputCheckbox name="lp" value="1" v-if="lastSubscription" @clicked="set('lp')">
                    <p class="text-14 pl-2">Your landing page</p>
                </InputCheckbox>

                <InputCheckbox name="google" value="1" v-if="lastSubscription" @clicked="set('google')">
                    <p class="text-14 pl-2">Your optimised campaigns</p>
                </InputCheckbox>

                <InputCheckbox name="ad" value="1" v-if="lastSubscription" @clicked="set('ad')">
                    <p class="text-14 pl-2">Your remaining ad budget</p>
                </InputCheckbox> -->

                <div class="bg-grey p-6 mt-4 flex items-center" v-if="subscription.product_id == 1 && waitingListCount != null">
                    <IconNotif class="w-4.5 h-4.5 shrink-0" />
                    <p class="text-14 pl-4">
                        There are currently {{ waitingListCount }} people on the waiting list to receive
                        {{ subscription.company.industry.name.toLowerCase() }} leads in {{ subscription.location_area.name }} – they will be
                        notified of your location’s availability upon cancellation
                    </p>
                </div>
            </div>

            <Select
                selectClass="!bg-grey text-15"
                class="mt-4"
                menuClass="!bg-grey"
                name="reason"
                label="Cancellation reason"
                placeholder="Select a reason"
                v-model:value="value.reason"
                :disabled="saving"
                :options="
                    reasons[subscription.product_id].map((r) => {
                        return { html: r, value: r }
                    })
                "
            />

            <Textarea
                label="Please provide more information"
                v-model:value="value.other_reason"
                class="mt-4"
                name="other_reason"
                :disabled="saving"
                v-if="otherItems.indexOf(value.reason) != -1"
            />

            <div class="pt-6">
                <ButtonSaving class="button-black h-12 px-6" :disabled="saving || !canSave"> Cancel subscription </ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Subscription from '~/models/subscription.js'
import PaymentMethod from '~/models/payment-method.js'
import Modal from '~/mixins/modal.js'
import SubscriptionBreakdown from '~/components/customer/blocks/subscription-breakdown-inline.vue'

export default {
    mixins: [Modal],

    data() {
        return {
            waitingListCount: null,
            value: {
                reason: null,
                other_reason: '',
            },
            descriptions: {
                area: () => 'Your location area ('+this.editingModel.location_area.name+')',
                lp: 'Your landing page',
                domain: 'Your domain name',
                numbers: 'Your local phone numbers',
                google: 'Your optimised campaigns',
                ad: 'Your remaining ad budget',
                lead: 'Your lead data',
                contact: 'Your contact data',
                deal: 'Your deal data',
                task: 'Your task and event data',
                reporting: 'Your reporting data',
                user: 'Your users',
                crm: 'Your CRM configuration',
            },
            reasons: { 1: [
                'I have too much work',
                'Not enough leads',
                'Lead quality was poor',
                'Didn\'t close enough jobs',
                'Too many calls',
                'Too expensive',
                'Not enough support',
                'Didn\'t like the landing page',
                'Other services are better',
                'I\'m reducing the size of my team',
                'I\'m closing my company',
                'I\'m happy, I just don\'t need your service any more',
                'Other',
            ], 2: [
                "I didn't like the CRM",
                "I didn't understand how to use the CRM",
                'Not enough support',
                'The CRM lacks key features or functionality',
                'The CRM doesn\'t connect with software I already use',
                'The CRM has too many bugs or glitches',
                "I'm not getting enough value from the CRM",
                "Other CRM's are better for my business",
                "I'm reducing the size of my team",
                "I'm closing my company",
                "I'm happy, I just don't need your service any more",
                'Other',
            ]},
            otherItems: [
                'Other',
                'Lead quality was poor',
                'Not enough support',
                'Didn\'t like the landing page',
                'Other services are better',
                "I didn't like the CRM",
                "I didn't understand how to use the CRM",
                "The CRM lacks key features or functionality",
                "The CRM doesn't connect with software I already use",
                "I'm not getting enough value from the CRM",
                "Other CRM's are better for my business",
            ]
        }
    },

    mounted() {
        this.getWaitingList()
        this.setup()
    },

    methods: {
        getWaitingList() {
            this.$axios.post('/actions/subscription-get-waiting-list-count/' + this.subscription.id).then((res) => {
                this.waitingListCount = res.count > 2 ? res.count : 2
            })
        },

        set(key) {
            this.value.checkboxes[key] = !this.value.checkboxes[key]
        },

        setup() {
            if (this.subscription.product_id == 1) {
                this.value.checkboxes = {
                    area: false,
                    lp: false,
                    domain: false,
                    numbers: false,
                    google: false,
                    ad: false,
                }
                
                if (this.lastSubscription) {
                    this.value.checkboxes = {
                        area: false,
                        numbers: false,
                        ad: false,
                    }
                }
            } else {
                this.value.checkboxes = {
                    lead: false,
                    contact: false,
                    deal: false,
                    task: false,
                    reporting: false,
                    user: false,
                    crm: false
                }
            }
        },
    },

    computed: {
        subscription() {
            return this.editingModel
        },

        canSave() {
            let good = true;
            for (let key in this.value.checkboxes) {
                if (this.value.checkboxes[key] == false) {
                    good = false;
                    break;
                }
            }

            if (this.otherItems.indexOf(this.value.reason) != -1) {
                good = good && this.value.other_reason != ''
            }

            return good 
                && this.value.reason != null
        },

        lastSubscription() {
            return (
                this.$authSanctum.getUser().subscriptions.filter((s) => {
                    return (
                        s.status.value.name != 'churned' &&
                        s.status.value.name != 'cancelled' &&
                        s.company_id == this.subscription.company_id &&
                        s.product_id == 1 &&
                        s.id != this.subscription.id
                    )
                }).length == 1
            )
        },
    },

    components: {
        SubscriptionBreakdown,
    },
}
</script>
